import { Injectable } from '@angular/core';
import { Http, URLSearchParams, RequestOptions, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { ConstantsService } from './constants.service';
import { AutenticacionService } from './autenticacion.service';
import { ValidatorService } from './tools/validator.service';
import { ErrorsService } from './tools/errors.service';

@Injectable()
export class InversionistasService {

    private service_url: string;

    constructor(
        private constantsService: ConstantsService,
        private http: Http,
        private authService: AutenticacionService,
        private validatorService: ValidatorService,
        private errorService: ErrorsService
    ) {
        this.service_url = this.constantsService.apiURL + '/inversionistas';
    }

    /**
     * Construye las cabeceras HTTP incluyendo el Token Bearer de Autenticación
     */
    private getHeaders(): Headers {
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');

        // Obtener token desde el servicio de autenticación o localStorage
        const token = this.authService.getToken ? this.authService.getToken() : localStorage.getItem('token');
        if (token) {
            headers.append('Authorization', `Bearer ${token}`);
        }

        return headers;
    }

    /**
     * Obtiene la lista paginada de inversionistas
     */
    public obtenerInversionistas(page: number = 1, filters: any = {}): Observable<any> {
        let params = new URLSearchParams();
        params.set('page', page.toString());

        if (filters.limit) {
            params.set('limit', filters.limit.toString());
        }
        if (filters.id) {
            params.set('id', filters.id.toString());
        }
        if (filters.search) {
            params.set('search', filters.search.toString());
        }

        // Se pasan tanto las cabeceras de autenticación como los parámetros GET
        let options = new RequestOptions({
            headers: this.getHeaders(),
            search: params
        });

        return this.http.get(this.service_url, options);
    }

    /**
     * Procesa la simulación/cálculo de rendimientos
     */
    public calcularInversion(data: any): Observable<any> {
        let options = new RequestOptions({ headers: this.getHeaders() });
        return this.http.post(`${this.service_url}/calcular`, JSON.stringify(data), options);
    }

    /**
     * Crea una nueva inversión
     */
    public crearInversion(data: any): Observable<any> {
        let options = new RequestOptions({ headers: this.getHeaders() });
        return this.http.post(`${this.service_url}/crearinversion`, JSON.stringify(data), options);
    }

    /**
     * Búsqueda rápida
     */
    public search(term: string, page: number = 1): Observable<any> {
        let params = new URLSearchParams();
        params.set('search', term);
        params.set('page', page.toString());

        let options = new RequestOptions({
            headers: this.getHeaders(),
            search: params
        });

        return this.http.get(`${this.service_url}/search`, options);
    }

    /**
     * Obtiene detalle por ID
     */
    public obtenerInversionistaPorId(id: number): Observable<any> {
        let options = new RequestOptions({ headers: this.getHeaders() });
        return this.http.get(`${this.service_url}/${id}`, options);
    }

    /**
     * Guardar inversionista
     */
    public guardarInversionista(data: any): Observable<any> {
        let options = new RequestOptions({ headers: this.getHeaders() });
        return this.http.post(this.service_url, JSON.stringify(data), options);
    }

    /**
     * Actualizar inversionista
     */
    public actualizarInversionista(id: number, data: any): Observable<any> {
        let options = new RequestOptions({ headers: this.getHeaders() });
        return this.http.put(`${this.service_url}/${id}`, JSON.stringify(data), options);
    }

    /**
     * Eliminar inversionista
     */
    public eliminarInversionista(id: number): Observable<any> {
        let options = new RequestOptions({ headers: this.getHeaders() });
        return this.http.delete(`${this.service_url}/${id}`, options);
    }

    // Método para obtener el detalle del pagaré con las cabeceras de autenticación
    public obtenerDetallePagare(id: number) {
        let options = new RequestOptions({ headers: this.getHeaders() });
        return this.http.get(`${this.service_url}/detalle/${id}`, options);
    }
    /**
    * Obtiene el calendario de pagos pendientes e intereses del mes actual
    */
    public obtenerCalendarioPagos(mes?: number, anio?: number): Observable<any> {
        let params: URLSearchParams = new URLSearchParams();

        if (mes) {
            params.set('mes', mes.toString());
        }
        if (anio) {
            params.set('anio', anio.toString());
        }

        let options = new RequestOptions({
            headers: this.getHeaders(),
            search: params
        });

        return this.http.get(`${this.service_url}/calendario-pagos`, options);
    }

    public getDefaultSchedule(): any {
        return {
            id: null,
            nombre: '',
            apellido_paterno: '',
            apellido_materno: '',
            email: '',
            telefono: '',
            promotor_id: null,
            monto_inicial: 0
        };
    }
    public procesarPagoCalendario(item: any): Observable<any> {
        let options = new RequestOptions({ headers: this.getHeaders() });
        return this.http.post(`${this.service_url}/calendario-pagos/pagar`, item, options);
    }
    public procesarReinversionCalendario(item: any): Observable<any> {
        let options = new RequestOptions({ headers: this.getHeaders() });
        return this.http.post(`${this.service_url}/calendario-pagos/reinvertir`, item, options);
    }

    /**
     * Calcula de forma previa los intereses y saldo a una fecha dada para un pagaré
     */
    public calcularPreviaMovimiento(idPagare: number, data: any): Observable<any> {
        let options = new RequestOptions({ headers: this.getHeaders() });
        return this.http.post(`${this.service_url}/detalle/${idPagare}/calcular-previa`, JSON.stringify(data), options);
    }

    /**
     * Calcula los nuevos montos de capital e intereses basados en el monto ingresado
     */
    public calcularNuevosMontosPagare(idPagare: number, data: any): Observable<any> {
        let options = new RequestOptions({ headers: this.getHeaders() });
        return this.http.post(`${this.service_url}/detalle/${idPagare}/calcular-nuevos-montos`, JSON.stringify(data), options);
    }

    /**
     * Guarda el nuevo movimiento para el pagaré especificado
     */
    public guardarMovimiento(idPagare: number, data: any): Observable<any> {
        let options = new RequestOptions({ headers: this.getHeaders() });
        return this.http.post(`${this.service_url}/detalle/${idPagare}/movimientos`, JSON.stringify(data), options);
    }
}


// WEBPACK FOOTER //
// ./src/app/services/inversionistas.service.ts